export default __webpack_public_path__ + "static/media/modal-info.740f28da.png";